import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  ImageField,
  NumberInput,
  required,
  useDataProvider,
} from "react-admin";
import { Box, Grid, Typography, InputAdornment } from "@material-ui/core";
import MROAccessGroupInput from "./MROAccessGroupInput";
import { get } from "lodash";
import { useFormContext } from "react-hook-form";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.spacing(3),
    },
    label: {
      marginRight: theme.spacing(0.5),
    },
  };
});

const ProductForm = ({
  productId,
  formValues,
  dirtyFields,
  modified,
  clientId,
  onMROAccessChange,
  onProductRecordChange,
  machineRecord,
  showPriceInput = true,
}) => {
  const [productRecord, setProductRecord] = useState(null);
  const [MROAccess, setMROAccess] = useState(null);
  const dataProvider = useDataProvider();
  const classes = useStyles();

  const { reset } = useFormContext();

  const machineMode = get(machineRecord, "machineMode", "commercial");

  // useEffect(() => {
  //   if (productRecord) {
  //     setValue("product.priceCash", productRecord.priceCash);
  //     setValue("product.priceCredit", productRecord.priceCredit);
  //     setValue("product.mroAccessGroup", productRecord.mroAccessGroup || []);
  //   }
  // }, [productRecord, setValue]);
  useEffect(() => {
    if (!productId) return null;
    getProductDetails();
  }, [productId]);
  const getProductDetails = async () => {
    try {
      const res = await dataProvider.getOne("products", { id: productId });
      const isCurrentSlotProduct = formValues?.product?.id === productId;
      const priceCash = isCurrentSlotProduct
        ? formValues?.product?.priceCash
        : res.data.priceCash;
      const priceCredit = isCurrentSlotProduct
        ? formValues?.product?.priceCredit
        : res.data.priceCredit;
      setProductRecord(res.data);
      reset({
        ...formValues,
        product: {
          ...formValues?.product,
          priceCash: priceCash,
          priceCredit: priceCredit,
          mroAccessGroup: res.data.mroAccessGroup || [],
        },
      });
      if (onProductRecordChange) {
        onProductRecordChange(res.data);
      }
    } catch (err) {
      console.error("Error fetching product:", err);
    }
  };
  const InlineField = ({ label, source }) => {
    return (
      <Grid display="flex" alignItems="flex-start" spacing={1} container>
        <Grid
          className={classes.label}
          style={{
            marginRight: "0.5rem",
            fontWeight: "bold",
            whiteSpace: "nowrap",
            marginTop: "0.2rem",
          }}
        >
          <Typography component="span">{label}:</Typography>
        </Grid>
        <Grid item xs>
          <Typography style={{ whiteSpace: "wrap" }}>
            {typeof source === "function" ? (
              source()
            ) : (
              <Typography component="span">
                {productRecord?.[source] ?? "N/A"}
              </Typography>
            )}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  if (!productRecord)
    return <Typography>Loading product details...</Typography>;
  //   const initialPriceCash = get(dirtyFields, "product.id")
  //     ? get(productRecord, "priceCash")
  //     : get(formValues, "product.priceCash", productRecord.priceCash);
  //console.log(initialPriceCash, "initialPriceCash");
  const isCurrentSlotProduct = formValues?.product?.id === productId;
  const initialPriceCash = isCurrentSlotProduct
    ? (formValues?.product?.priceCash ?? "")
    : (productRecord?.priceCash ?? "");
  const initialPriceCredit = isCurrentSlotProduct
    ? (formValues?.product?.priceCredit ?? "")
    : (productRecord?.priceCredit ?? "");
  const initialMROAccessGroup = get(modified, "product.id")
    ? get(productRecord, "mroAccessGroup", null)
    : get(
        formValues,
        "product.mroAccessGroup",
        productRecord.mroAccessGroup || null,
      );

  const price = (msg) => (value) => {
    const regex = /^\d*(\.\d{0,2})?$/;
    if (!regex.test(value)) {
      return msg || "Invalid";
    }
  };

  const safeValue = (value) =>
    value !== null && value !== undefined ? value : "";
  return (
    <>
      <Grid container spacing={3} className={classes.root}>
        <Grid item xs={12} md={4}>
          <ImageField record={productRecord} source="image.src" />
        </Grid>
        <Grid item xs={12} md={8}>
          <Grid container spacing={3}>
            <InlineField label="Product Name" source="name" />
            <InlineField label="Description" source="description" />
            <InlineField label="SKU" source="sku" />
            <InlineField label="Serial Number" source="serialNumber" />
            <InlineField
              label="Price (RM)"
              source={() => (
                <Typography>
                  {(productRecord?.priceCash ?? 0).toLocaleString("en-MY", {
                    style: "currency",
                    currency: "MYR",
                  })}
                </Typography>
              )}
            />
            {machineMode === "mro" && (
              <InlineField label="Price (Credit)" source="priceCredit" />
            )}
            {machineMode === "mro" && (
              <InlineField label="Price (Cash)" source="priceCash" />
            )}
            {machineMode === "mro" ? (
              <>
                {showPriceInput && (
                  <>
                    <Grid item xs={12}>
                      <NumberInput
                        label="Price (Credit)"
                        source="product.priceCredit"
                        fullWidth
                        validate={[
                          required("Please enter a credit price"),
                          price(
                            "Please enter a valid credit price with no more than two decimals.",
                          ),
                        ]}
                        defaultValue={safeValue(initialPriceCredit)}
                        FormHelperTextProps={{ style: { display: "none" } }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <NumberInput
                        label="Price (Cash)"
                        source="product.priceCash"
                        fullWidth
                        validate={[
                          required("Please enter a cash price"),
                          price(
                            "Please enter a valid cash price with no more than two decimals.",
                          ),
                        ]}
                        defaultValue={safeValue(initialPriceCash)}
                        FormHelperTextProps={{ style: { display: "none" } }}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12}>
                  <MROAccessGroupInput
                    name="product.mroAccessGroup"
                    client={clientId}
                    initialValue={productRecord.mroAccessGroup || []}
                    value={formValues?.product?.mroAccessGroup || []}
                    onValueChange={(updatedValues) => {
                      onMROAccessChange(updatedValues);
                    }}
                  />
                </Grid>
              </>
            ) : (
              <>
                <input
                  type="hidden"
                  name="product.priceCredit"
                  value={safeValue(initialPriceCredit)}
                />
                <input
                  type="hidden"
                  name="product.priceCash"
                  value={safeValue(initialPriceCash)}
                />
                <input
                  type="hidden"
                  name="product.mroAccessGroup"
                  value={safeValue(initialMROAccessGroup)}
                />
              </>
            )}
            {(machineMode === "commercial" || machineMode === "event") &&
            showPriceInput ? (
              <Grid item xs={12}>
                <NumberInput
                  key={productId}
                  label="Price"
                  source="product.priceCash"
                  fullWidth
                  variant="outlined"
                  defaultValue={safeValue(initialPriceCash)}
                  validate={[
                    required("Please enter a price"),
                    price(
                      "Please enter a valid price with no more than two decimals.",
                    ),
                  ]}
                />
              </Grid>
            ) : (
              <>
                <input
                  type="hidden"
                  name="product.priceCash"
                  value={safeValue(initialPriceCash)}
                />
              </>
            )}
            {productRecord && (
              <>
                <input
                  type="hidden"
                  name="product.description"
                  value={safeValue(productRecord.description)}
                />
                <input
                  type="hidden"
                  name="product.categoryId"
                  value={safeValue(productRecord.category)}
                />
                <input
                  type="hidden"
                  name="product.limitationRule"
                  value={safeValue(productRecord.limitationRule)}
                />
                <input
                  type="hidden"
                  name="product.image.src"
                  value={safeValue(productRecord?.image?.src)}
                />
                <input
                  type="hidden"
                  name="product.infographic.src"
                  value={safeValue(productRecord?.infographic?.src)}
                />
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ProductForm;
